export default __webpack_public_path__ + "static/media/xmas-tree.539a13f3.svg";